import {Injectable} from '@angular/core';
import {environment} from '../environments/environment';
import {HttpClient} from '@angular/common/http';
import {type} from 'node:os';

const WWW = environment.WWW;
const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  isMobile = {
    android: navigator.userAgent.match(/Android/i),
    blackBerry: navigator.userAgent.match(/BlackBerry/i),
    iOS: navigator.userAgent.match(/iPhone|iPad|iPod/i),
    opera: navigator.userAgent.match(/Opera Mini/i),
    windows: navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i),
    any: () => {
      return (
        !!this.isMobile.android || !!this.isMobile.blackBerry || !!this.isMobile.iOS || !!this.isMobile.opera || !!this.isMobile.windows
      );
    },
  };

  constructor(private http: HttpClient) {
  }

  kebabCase(name: string) {
    return name.replace(/\s+/g, '-').toLowerCase();
  }

  getServerTime() {
    return this.http.get(`${API}/api/general/time`);
  }

  getAllTimezones() {
    return this.http.get(`${API}/api/general/timezones`);
  }

  createContact(contactName: string, contactEmail: string, contactMessage: string) {
    return this.http.post(`${API}/api/general/contact`, {contactName, contactEmail, contactMessage});
  }

  sendMobileLink(phoneNumber: string) {
    const body = {phoneNumber};
    return this.http.post(`${API}/api/general/mobile`, body);
  }

}
